module.exports = __webpack_public_path__ + "static/media/list.f96a7154.svg";